import { render, staticRenderFns } from "./EntradaTrasladoFormComponent.vue?vue&type=template&id=3e05ef8a&"
import script from "./EntradaTrasladoFormComponent.vue?vue&type=script&lang=js&"
export * from "./EntradaTrasladoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports